module.exports = __webpack_public_path__ + "static/media/tap.37645e99.svg";